import { useRouter } from "next/router";
import { Company } from "../../../../users/models/company.model";

interface ValueTemplateProps {
    companies: Company[];
}

const ValueTemplate = (props: ValueTemplateProps) => {
    const { companies } = props;

    const router = useRouter();
    const { companyId, locationId } = router.query as {
        companyId?: string;
        locationId?: string;
    };

    const company = companies.find((company) => company.id === companyId);
    if (!company) return <div className="text-default">-</div>;

    if (locationId) {
        const location = company.locations?.find(
            (location) => location.id === locationId
        );
        return <div className="text-default">{location?.name || "-"}</div>;
    }

    return <div className="text-default">{company.name || "-"}</div>;
};

export default ValueTemplate;
